import React from "react";
import {LineChartConfig} from "./LineChartConfig";
import {LineChartFilters} from "./LineChartFilters";

export class LineChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeFilter: this.props.defaultFilter ?? "sixMonths"
        };
    }

    renderGraph(graphVariant, highChartInstance, minRange = undefined, maxRange = undefined) {
        const chartContainer = document.querySelector(`#${this.props.id}-line-graph-container`);
        const title = chartContainer.querySelector(".line-chart-widget__subTitle");

        highChartInstance.xAxis.forEach((axis) => {
            if (graphVariant === "data") {
                axis.setExtremes(undefined, undefined, true, true);
            } else {
                axis.setExtremes(Number.parseInt(minRange), Number.parseInt(maxRange), true, true);
            }
        });
        highChartInstance.series.forEach((chartSerie) => {
            title.innerHTML = chartSerie.userOptions.custom.dataHeaders[graphVariant];
        });
        this.setState({activeFilter: graphVariant});
    }

    componentDidMount() {
        const {id, series, legendaEnabled, chartBackgroundColor = "transparent"} = this.props;
        const legendaEnabledValue = typeof legendaEnabled === 'string' ? legendaEnabled === 'true' : !!legendaEnabled;
        const chartContainer = document.querySelector(`#${id}-line-graph-container`);
        const chart = document.querySelector(`#${id}`);

        if (!chart) {
            return;
        }

        const highchart = Highcharts.chart(
            chart.id,
            LineChartConfig(series, legendaEnabledValue, chartBackgroundColor)
        );
        
        chartContainer.querySelectorAll(".line-chart-widget__graph-menu > button").forEach((button) => {
            const variant = button.dataset.variant && (button.dataset.active === "false" || !button.dataset.active)
                ? button.dataset.variant
                : "data";

            button.addEventListener("click", () => {
                
                // if the clicked button is already active, turn off the filter
                this.renderGraph(
                    variant === this.state.activeFilter ? "data": variant,
                    highchart,
                    variant === this.state.activeFilter ? undefined : button.dataset.minrange,
                    variant === this.state.activeFilter ? undefined:  button.dataset.maxrange
                );
            });
        });

        const defaultFilterButton = chartContainer.querySelector(`.line-chart-widget__graph-menu > button[data-variant='${this.state.activeFilter}']`);
        const defaultVariant = defaultFilterButton?.dataset?.variant || "data";
        const minRange = defaultFilterButton?.dataset?.minrange;
        const maxRange = defaultFilterButton?.dataset?.maxrange;
        this.renderGraph(defaultVariant, highchart, minRange, maxRange);
    }

    render() {
        const {id, title, chartTitle, chartSubTitle, hideDisabledFilters, isInEditMode, series, filters} = this.props;
        const hideDisabledFiltersValue = typeof hideDisabledFilters === 'string' ? hideDisabledFilters === 'true' : !!hideDisabledFilters;
        const isInEditModeValue = typeof isInEditMode === 'string' ? isInEditMode === 'true' : !!isInEditMode;

        const maxRange = series.reduce((max, serie) => {
            const maxValue = Math.max(...serie.data.map(point => point[0]));
            return Math.max(max, maxValue);
        }, -Infinity);

        return (
            <section id={`${id}-line-graph-container`} className="line-chart-widget">
                <h2 className="line-chart-widget__title">{title}</h2>
                <div className="line-chart-widget__divider"></div>

                <LineChartFilters filters={filters} activeFilter={this.state.activeFilter} maxRangeTimestamp={maxRange}
                                  hideDisabledFilters={hideDisabledFiltersValue}/>

                <h3 className="line-chart-widget__subTitle">{chartTitle}</h3>
                <p className="line-chart-widget__info">{chartSubTitle}</p>

                {isInEditModeValue ? (
                    <p className="line-chart-widget__info">
                        Highchart graphs currently cannot be shown for the kentico pagebuilder when checked out
                    </p>
                ) : (
                    <div id={id} className="line-chart-widget__graph"></div>
                )}
            </section>
        );
    }
}